module.exports = __webpack_public_path__ + "static/media/BaoLong.03fa5af0.png";